export const ERRORS = {
  NO_CONNECTION: 'ERRORS/NO_CONNECTION',
};


// WEBPACK FOOTER //
// ./src/utils/errorCodes.js